import { render, staticRenderFns } from "./AnaliseMargem2Rede.vue?vue&type=template&id=36df3c87&scoped=true&"
import script from "./AnaliseMargem2Rede.vue?vue&type=script&lang=js&"
export * from "./AnaliseMargem2Rede.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseMargem2Rede.vue?vue&type=style&index=0&id=36df3c87&scoped=true&lang=css&"
import style1 from "./AnaliseMargem2Rede.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df3c87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
